import PropTypes from 'prop-types';
import './PopularSearches.scss';

export const PopularSearches = (props) => {
  const { popularSearches } = props;

  return (
    <div className="popular-searches">
      <p className="popular-searches__title">Popular searches:</p>
      <ul className="popular-searches__list" data-testid="popular-searches">
        {popularSearches?.map(({ key, name }, index) => (
          <li className="list-item" key={index}>
            <a className="list-item__link" href={key}>
              {name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

PopularSearches.propTypes = {
  popularSearches: PropTypes.arrayOf(PropTypes.object),
};
